import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
// import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import {
  getTodaysData,
  validateName,
  validateRequired,
} from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { getQtnJobList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { useDispatch, useSelector } from "react-redux";
// import FileViewerModalNew from "../../../../Components/FileViewer/FileViewerModalForHB";
// import FileUploadComponentNew from "../../../../Components/formElements/FileUploadComponentNew";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import './Entry.css'



const EntryModel = React.forwardRef((props, ref) => {

  let userData = useSelector((state) => state?.user?.data);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [checkerNameOptions, setCheckerNameOptions] = useState([]);
  const [getErrorFields, setErrorFields] = useState([]);
  const FailureEntry = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureEntry] = useState(FailureEntry);

  const [getShowFailureModal, setShowFailureEntry] = useState(false);

  // eslint-disable-next-line
  const [fileDeleted, setFileDeleted] = useState(false);
  
const handleAttachmentDeleted = ({ attachmentId, hasFiles, remainingCount }) => {
    console.log("handleAttachmentDeleted called:", { attachmentId, hasFiles, remainingCount });
    
    //  If NO files remain, clear the supportingDoc field
    if (!hasFiles) {
      console.log("No files remaining, clearing supportingDoc");
      setFormInputs((prev) => ({
        ...prev,
        supportingDoc: "",  // ← Clear the attachment ID
      }));
      setFileDeleted(true); 
    } else {
      //  If files still exist, update with new count (optional)
      console.log("Files still exist, count:", remainingCount);
    }
  };

  const message = {
    VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
    VALID_MAIL_ID: "Please enter a valid email address.",
    VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
    VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
    VALID_ALTERNATE_CONTACT_NUMBER:
      "Please enter a valid alternate contact number.",
    VALID_PURPOSE_JUSTIFICATION:
      "Please ensure the justification is under 500 characters.",
    VALID_POSTAL_CODE:
      "Enter a 6-character postal code with uppercase letters and numbers only",
    VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
    VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
    EXIStS_MAIL_ID: "Email already exists",
    EXIStS_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
    EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
    FILL_REQUIRED_FIELD: "Please fill the required field",
    ALTERNATE_MAIL_ID: "Email ID is same",
    ALTERNATE_CONTACT_NUMBER: "Contact number is same",
    VALID_CLIENT_NAME: "Enter Client Name",
    VALID_COMAPANY_NAME: "Enter Company Name",
    BUILDING_NAME: "Enter Building Name",
    LOCATION: "Enter Location",
  };

  const [validation, setValidation] = useState({});
  // console.log(">>validation", validation);

  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    createdName: userData?.firstName || "",
    transactionDate: getTodaysData() || "",
    clientName: "",
    companyName: "",
    projectName: "",
    location: "",
    validUntil: "",
    estimationDate: getTodaysData() || "",
    salesOfficerName: "",
    // headerStatus: "Quotation Updated",
    transactionCodeType: "",
    type: "",
    designerName: userData?.firstName || "",
    checkerName: "",
    checkerNameCode: "",
    checkerNameDesc: "",
    estimationStatus: "Estimation Pending",
    version: "V0",
    documentNumber: "",
     supportingDoc: "",
  });
  // console.log(">>formInputs",formInputs)

  // useEffect(() => {

  //   setFormInputs((prev) => ({
  //     ...prev,
  //     [getDropdownData?.textField]: getDropdownData?.name,
  //     [getDropdownData?.textCode]: getDropdownData?.textCode,
  //     [getDropdownData?.textDesc]: getDropdownData?.textDesc,
  //   }));

  //   // Separate condition for typeS
  //   if (getDropdownData?.textField === "typeS") {
  //     setFormInputs((prev) => ({
  //       ...prev,
  //       typeS: getDropdownData?.name,
  //     }));
  //   }
  //   setValidation((prev) => ({
  //     ...prev,
  //     [getDropdownData?.textField]: "",
  //     [getDropdownData?.textCode]: "",
  //     [getDropdownData?.textDesc]: "",
  //   }));
  // }, [getDropdownData]);

  useEffect(() => {
    // console.log(">>getDropdonw",getDropdownData)
    setFormInputs((prev) => {
      const updated = {
        ...prev,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.textCode,
        [getDropdownData?.textDesc]: getDropdownData?.textDesc,
      };

      // ✅ Handle dropdown for typeS
      if (getDropdownData?.textField === "type") {
        updated.typeS = getDropdownData?.name;

        // When switching between Job and Quotation, clear opposite field
        if (getDropdownData?.name === "Quotation") {
          updated.jobReferenceNr = "";
        } else if (getDropdownData?.name === "Job") {
          updated.qtnReferenceNr = "";
        }
      }

      return updated;
    });

    setValidation((prev) => {
      const updatedValidation = {
        ...prev,
        [getDropdownData?.textField]: "",
        [getDropdownData?.textCode]: "",
        [getDropdownData?.textDesc]: "",
      };

      // ✅ Also clear validation messages for the opposite field
      if (getDropdownData?.textField === "type") {
        updatedValidation.jobReferenceNr = "";
        updatedValidation.qtnReferenceNr = "";
      }

      return updatedValidation;
    });
  }, [getDropdownData]);

  useEffect(() => {
    if (!props.show) {
      setFormInputs({}); // reset your form data
    }
  }, [props.show]);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    transactionDate: getTodaysData() || "",
    clientCompanyName: "",
    projectName: "",
    location: "",
    validUntil: "",
    estimationDate: getTodaysData() || "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    type: "",
    // checkerName: "",
    designerName: "",
    revision: "R0",
    checkerName: "",
    checkerNameCode: "",
    checkerNameDesc: "",
    supportingDoc: "",
  };

  const typeS = [
    { id: 1, name: "Job", transactionCodeType: "JB" },
    { id: 2, name: "Quotation", transactionCodeType: "QTN" },
  ];



  const onSuccessUploadDocumentType = (data) => {
    const value = data.attachmentId || data.id;
    setFormInputs((prev) => ({
      ...prev,
      [data.fieldName]: value,
    }));
  };

  
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };


  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handleCancel = () => {
    setFormInputs((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleInputChanges = (e) => {
    let error = "";
    const { name, value } = e.target;
    setFormInputs((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  

  const handleUppercaseBlur = (e) => {
  const { name, value } = e.target;

  if (!value) return;

  setFormInputs((prev) => ({
    ...prev,
    [name]: value.toUpperCase(),
  }));
};



  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    //  Prevent multiple clicks
    if (isSaving) return;
    setIsSaving(true);
    setDisabled(true);

    const jobError = await handleCheckValidation({
      target: { name: "jobReferenceNr", value: formInputs.jobReferenceNr },
    });

    const qtnError = await handleCheckValidation({
      target: { name: "qtnReferenceNr", value: formInputs.qtnReferenceNr },
    });

    if (jobError || qtnError) {
      toast.error("Please fix validation errors before saving.", {
        duration: 4000,
        position: "top-right",
      });
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    const requiredFields = [];
    const anyFieldNotEmpty = Object.values(validation).some(
      (value) => value !== null && value !== ""
    );

    if (anyFieldNotEmpty) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateRequired(formInputs.clientName)) {
      requiredFields.push(`${message.VALID_CLIENT_NAME}`);
      setErrorFields(requiredFields);
      setValidation((prev) => ({
        ...prev,
        clientName: message.VALID_CLIENT_NAME,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateRequired(formInputs.companyName)) {
      requiredFields.push(`${message.VALID_COMAPANY_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureEntry(true);
      setValidation((prev) => ({
        ...prev,
        companyName: message.VALID_COMAPANY_NAME,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateRequired(formInputs.buildingName)) {
      requiredFields.push(`${message.BUILDING_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureEntry(true);
      setValidation((prev) => ({
        ...prev,
        buildingName: message.BUILDING_NAME,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateRequired(formInputs?.location)) {
      requiredFields.push(`${message.LOCATION}`);
      setErrorFields(requiredFields);
      setShowFailureEntry(true);
      setValidation((prev) => ({
        ...prev,
        location: message.LOCATION,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateRequired(formInputs.salesOfficerName)) {
      requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureEntry(true);
      setValidation((prev) => ({
        ...prev,
        salesOfficerName: message.VALID_CUSTOMER_NAME,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateRequired(formInputs?.type)) {
      requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
      setErrorFields(requiredFields);
      setShowFailureEntry(true);
      setValidation((prev) => ({
        ...prev,
        type: message.FILL_REQUIRED_FIELD,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (!validateName(formInputs.salesOfficerName)) {
      requiredFields.push(`${message.VALID_CUSTOMER_NAME}`);
      setErrorFields(requiredFields);
      setShowFailureEntry(true);
      setValidation((prev) => ({
        ...prev,
        salesOfficerName: message.VALID_CUSTOMER_NAME,
      }));
      setIsSaving(false);
      setDisabled(false);
      return;
    }

    if (formInputs?.type === "Quotation") {
      if (!validateRequired(formInputs?.qtnReferenceNr)) {
        requiredFields.push(message.FILL_REQUIRED_FIELD);
        setErrorFields(requiredFields);
        setShowFailureEntry(true);
        setValidation((prev) => ({
          ...prev,
          qtnReferenceNr: message.FILL_REQUIRED_FIELD,
        }));
        setIsSaving(false);
        setDisabled(false);
        return;
      }
    }

    if (formInputs?.type === "Job") {
      if (!validateRequired(formInputs?.jobReferenceNr)) {
        requiredFields.push(message.FILL_REQUIRED_FIELD);
        setErrorFields(requiredFields);
        setShowFailureEntry(true);
        setValidation((prev) => ({
          ...prev,
          jobReferenceNr: message.FILL_REQUIRED_FIELD,
        }));
        setIsSaving(false);
        setDisabled(false);
        return;
      }
    }

    const transactionCodeType = formInputs?.type === "Job" ? "JB" : "QTN";
    const headerStatus =
      formInputs?.type === "Job" ? "Job Created" : "Quotation Created";

    const obj = {
      data: {
        ...formInputs,
        transactionCodeType,
        headerStatus,
        estHeaderStatus: "Estimation Pending",
      },
    };
    // console.log(">>obj", obj);

    try {
      const item = await ItemService.addQuotationOrJob(obj);

      if (item?.status === 200) {
        toast.success(item?.message || "Added successfully", {
          duration: 2000,
          position: "top-right",
        });

        props.onHide();
        dispatch(
          getQtnJobList({
            queryName: "Get_ENQUIRY_LIST",
            module: "",
            page: 1,
            per_page: 10,
          })
        );
        navigate(CustomerConstants.CUSTOMER_V4_HB_ENTRY_LIST);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("Something went wrong!", {
        duration: 4000,
        position: "top-right",
      });
    } finally {
      setIsSaving(false);
      setDisabled(false);
    }
  };

  const hideFailureModal = () => {
    setShowFailureEntry(false);
  };

  // Load Checker names
  const loadCheckerNames = async () => {
    try {
      const payload = { queryName: "Get_EMPLOYEE_LIST", category: "DESIGN" };
      const response = await ItemService.generateCustomerQuery(payload);
      if (response?.status === 200) {
        const mappedData = response.data.map((emp) => ({
          checkerNameCode: emp.userId,
          name: emp.firstName,
          textDesc: emp.lastName || "",
        }));
        setCheckerNameOptions(mappedData);

        // Set default if nothing selected
        if (!formInputs.checkerNameCode && mappedData.length > 0) {
          setFormInputs((prev) => ({
            ...prev,
            checkerName: mappedData[0].name,
            checkerNameCode: mappedData[0].checkerNameCode,
            checkerNameDesc: mappedData[0].textDesc,
          }));
        }
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  useEffect(() => {
    loadCheckerNames();
    // eslint-disable-next-line
  }, []);
  //validation

  const handleCheckValidation = async ({ target: { name, value } }) => {
    if (!value) return false;

    let obj = {};
    let queryName = "";

    // Choose the correct query based on field name
    if (name === "jobReferenceNr") {
      queryName = "Check_JobReferenceNr_Duplication";
      obj = { queryName, jobReferenceNr: value };
    } else if (name === "qtnReferenceNr") {
      queryName = "Check_QtnReferenceNr_Duplication";
      obj = { queryName, qtnReferenceNr: value };
    } else {
      return false;
    }

    try {
      const item = await ItemService.generateCustomerQueryHb(obj);
      let errorMsg = "";

      if (
        item?.status === 200 &&
        item?.data?.length > 0 &&
        item.data[0].isItDuplicate === "true"
      ) {
        errorMsg = `This ${
          name === "jobReferenceNr" ? "Job" : "Quotation"
        } Number already exists.`;
      }

      // Update validation state
      setValidation((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));

      return errorMsg ? true : false;
    } catch (err) {
      console.error("Error during validation:", err);
      setValidation((prev) => ({
        ...prev,
        [name]: "Unable to validate. Please try again.",
      }));
      return true;
    }
  };

 
  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Project Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">BI</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Basic Information</span>
                  {/* <span className="subHeaderTitle">Inquire Details</span> */}
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Date"
                            name="transactionDate"
                            id="transactionDate"
                            value={formInputs?.transactionDate}
                            onChange={handleInputChanges}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox uppercase-input"
                            type="text"
                            label="Client Name"
                            name="clientName"
                            id="clientName"
                            value={formInputs?.clientName || ""}
                            error={validation.clientName || ""}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                            
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox uppercase-input"
                            label="Company Name"
                            name="companyName"
                            id="companyName"
                            error={validation.companyName || ""}
                            value={formInputs?.companyName}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox uppercase-input"
                            label="Building name"
                            name="buildingName"
                            id="buildingName"
                            value={formInputs?.buildingName}
                            error={validation.buildingName || ""}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                            
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            className="inputBox uppercase-input"
                            label="Location"
                            placeholder=""
                            name="location"
                            id="location"
                            value={formInputs?.location}
                            error={validation.location || ""}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                            
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox uppercase-input"
                            label="Sales Officer Name"
                            name="salesOfficerName"
                            id="salesOfficerName"
                            value={formInputs?.salesOfficerName}
                            error={validation.salesOfficerName || ""}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                            
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Type"
                            placeholder=""
                            data={typeS}
                            id="type"
                            iconClassName="dropdownIcon"
                            name="type"
                            code="typeCode"
                            description="typeDesc"
                            setValue={formInputs.type}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation.type}
                          />
                        </Col>
                        {formInputs?.type === "Job" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Job Reference Number"
                                name="jobReferenceNr"
                                id="jobReferenceNr"
                                value={formInputs.jobReferenceNr}
                                error={validation.jobReferenceNr || ""}
                                onChange={handleInputChanges}
                                onBlur={handleCheckValidation}
                                
                              />
                            </Col>
                          </>
                        )}
                        {formInputs?.type === "Quotation" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commLeftRightPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Quotation Reference Number"
                                name="qtnReferenceNr"
                                id="qtnReferenceNr"
                                value={formInputs.qtnReferenceNr}
                                error={validation?.qtnReferenceNr || ""}
                                onChange={handleInputChanges}
                                onBlur={handleCheckValidation}
                              />
                            </Col>
                          </>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Version"
                            name="version"
                            id="version"
                            value={formInputs?.version}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Estimation Date"
                            name="estimationDate"
                            id="estimationDate"
                            value={formInputs?.estimationDate}
                            onChange={handleInputChanges}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox uppercase-input"
                            label="Designer"
                            name="designerName"
                            id="designerName"
                            value={formInputs?.designerName}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                            disabled={true}
                            
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Checker Name"
                            placeholder=""
                            data={checkerNameOptions}
                            id="checkerName"
                            iconClassName="dropdownIcon"
                            name="checkerName"
                            code="checkerNameCode"
                            description="checkerNameDesc"
                            setValue={formInputs?.checkerName}
                            getvalue={setDropdownData}
                            required={true}
                            error={validation?.checkerName}
                          />
                        
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <TextAreaField
                            className="inputBox uppercase-input"
                            label="Remarks"
                            placeholder=""
                            name="remarks"
                            id="remarks"
                            value={formInputs?.remarks}
                            error={validation.remarks || ""}
                            onBlur={handleUppercaseBlur}
                            onChange={handleInputChanges}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponentForHB
                            id="supportingDoc"
                            name="supportingDoc"
                            label="Supporting Document"
                            // allowedTypes={[
                            //   "image/png",
                            //   "image/jpeg",
                            //   "application/pdf",
                            // ]}
                            allowedTypes={["image/png", "image/jpeg", "application/pdf", ".dwg"]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.supportingDoc || ""}
                          />
  
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          {(formInputs?.supportingDoc && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.supportingDoc)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>

                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled || isSaving}
                    onClick={handleSave}
                  >
                    {isSaving ? "Saving..." : "Save"}
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureFuelData={getFailureEntry}
          requiredfields={getErrorFields}
        />
       
        <FileViewerModalForHB
                  show={getShowFileViewModal}
                  onHide={handleViewFileHide}
                  fileid={getFileViewData}
                  onDeleteSuccess={handleAttachmentDeleted}
                />
      </Modal.Body>
    </Modal>
  );
});

export default EntryModel;
